module.exports = __webpack_public_path__ + "img/integralIcon2.1ef946b5.png";